// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuthenticationPage_wrapper__3iVq2","greeting":"AuthenticationPage_greeting__1c6rb","button":"AuthenticationPage_button__1_Jg7","text":"AuthenticationPage_text__2V4gD"};